// extracted by mini-css-extract-plugin
export default {"ProjectDetailsPage":"ProjectDetailsPage_ProjectDetailsPage__95Kbi","pageRow":"ProjectDetailsPage_pageRow__45NZF"};